module.exports = __webpack_public_path__ + "static/media/database.2355e814.jpg";